import script from "./ServiceContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceContent.vue?vue&type=script&setup=true&lang=js"

import "./ServiceContent.vue?vue&type=style&index=0&id=8db46a36&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8db46a36"]])

export default __exports__